import { useEffect } from "react";

import { useAppIsReady } from "Flocknote/stateHooks";

import { useActiveAction } from "Dashboard/components/WhatsNext/whatsNextStore";
import {
  navSectionKeys,
  useActiveSectionKey,
  useRouteSectionKey,
  useNavToggleRef,
  useNavBarIsFullyLoaded,
  useSetGroupsWereAutoOpened,
} from "NavBar/navBarStore";
import {
  useEffectiveIsExpanded,
  useExportedFloatingToolbarHeight,
  useIsComposerMinimized,
  useIsFullScreen,
} from "NavBar/stateHooks";

import Portal from "Utilities/PortalMaker";

import { useSuperSearchState } from "NavBar/TopArea/Toolbar/SuperSearch/superSearchStore";

import useShowGroupsHint from "./useShowGroupsHint";
import FloatingToolbar from "./FloatingToolbar/FloatingToolbar";
import NavCloseButton from "./NavCloseButton";

const NavToggle = () => {
  useExportedFloatingToolbarHeight();
  const isFullScreen = useIsFullScreen();
  const [isExpanded, setIsExpanded] = useEffectiveIsExpanded();
  const isComposerMinimized = useIsComposerMinimized();
  const navBarIsFullyLoaded = useNavBarIsFullyLoaded();
  const navToggleRef = useNavToggleRef();
  const showGroupsHint = useShowGroupsHint();
  const setGroupsWereAutoOpened = useSetGroupsWereAutoOpened();
  const appIsReady = useAppIsReady();
  const [activeAction] = useActiveAction();
  const [activeSectionKey, setActiveSectionKey] = useActiveSectionKey();
  const routeSectionKey = useRouteSectionKey();
  const superSearchState = useSuperSearchState(true);

  useEffect(() => {
    if (
      activeAction &&
      !isExpanded &&
      isFullScreen &&
      activeSectionKey === navSectionKeys.groups
    ) {
      setActiveSectionKey(navSectionKeys.nothing);
    }
  }, [
    activeAction,
    isExpanded,
    isFullScreen,
    activeSectionKey,
    setActiveSectionKey,
  ]);

  const handleClick = () => {
    setGroupsWereAutoOpened(false);
    if (isExpanded) {
      const instance = window.backgroundJobCheckerInstance;
      if (instance && !instance.$el.hasClass("hide_manager")) {
        instance.showHide();
      }
    } else if (!showGroupsHint) {
      setActiveSectionKey(routeSectionKey);
    }
    setIsExpanded(!isExpanded);
  };

  const sharedProps = {
    isExpanded,
    isFullScreen,
    isComposerMinimized,
    navBarIsFullyLoaded,
    appIsReady,
    handleClick,
  };

  return (
    <>
      <NavCloseButton {...sharedProps} />
      <Portal to={document.getElementById("fnReactHolder") || document.body}>
        <FloatingToolbar
          {...sharedProps}
          navToggleRef={navToggleRef}
          showGroupsHint={showGroupsHint}
          activeSectionKey={routeSectionKey}
          superSearchState={superSearchState}
        />
      </Portal>
    </>
  );
};

export default NavToggle;
